import {
  SINGLE_RESULT_CHAR_THRESHOLD,
  NATURAL_LANGUAGE_WORD_THRESHOLD,
  SEARCH_CHIP_CONFIG,
  SEARCH_MODES
} from "./constants";
import { ENTITY_BY_FILTER_NAME } from "../../constants/entityTypes";
import { FilterVisibility } from "../Filters/constants";

const getIconForType = typeKey =>
  ENTITY_BY_FILTER_NAME[typeKey]?.iconName ??
  SEARCH_CHIP_CONFIG[typeKey]?.iconName;

// Dynamic mode icon helper
// - in similarity mode, always returns "similar_tracks"
// - in search mode, dynamic behavior:
//     - swap to result icon on exact title match or single-result-with-3+chars
//     - swap to text_search / natural_language based on word count + 0 results
//     - otherwise plain "search"
export const getModeIcon = (mode, input, autocompleteResults) => {
  if (mode === SEARCH_MODES.SIMILARITY) return "similar_tracks";

  if (!input) return "search";

  // If input exactly matches a suggestion's name/title, use that result's icon
  const normalizedInput = input.trim().toLowerCase();
  const exactMatch = autocompleteResults.find(
    item => (item.name || item.title || "").toLowerCase() === normalizedInput
  );
  if (exactMatch) {
    const typeKey = (exactMatch.type || "").toLowerCase();
    return getIconForType(typeKey) || "search";
  }

  // If we've typed at least three letters and only get one result, use that result's icon
  if (
    input.length >= SINGLE_RESULT_CHAR_THRESHOLD &&
    autocompleteResults.length === 1
  ) {
    const item = autocompleteResults[0];
    const typeKey = (item.type || "").toLowerCase();
    return getIconForType(typeKey) || "search";
  }

  // Word count determines text_search vs natural_language
  const wordCount = input.trim().split(/\s+/).length;
  if (
    wordCount < NATURAL_LANGUAGE_WORD_THRESHOLD &&
    autocompleteResults.length === 0
  ) {
    return "text_search";
  }
  if (wordCount >= NATURAL_LANGUAGE_WORD_THRESHOLD) {
    return "natural_language";
  }
  return "search";
};

// Only System_Hidden genres/tags are kept out of search; Hidden / Hidden_Quick_Filter
// stay out of the Filters panel but are still searchable
export const filterByVisibility = filterItems =>
  filterItems.filter(f => f.visibility !== FilterVisibility.SYSTEM_HIDDEN);
